import { ActionReducerMap } from '@ngrx/store';

import { oauthReducer, toastReducer as sharedToastReducer, sharedRootReducer } from '@digihaven/shared';

import { authenticationReducer } from '@reducers/authentication.reducer';
import { reducer as functionalityReducer } from '@reducers/functionality.reducer';

import { ApplicationState } from 'state';

import { filterReducer } from './filter.reducer';
import { organisationReducer } from './organisation.reducer';
import { tokenReducer } from './token.reducer';
import { userReducer } from './user.reducer';

export const rootReducer: ActionReducerMap<ApplicationState> = {
    ...sharedRootReducer,
    authentication: authenticationReducer,
    token: tokenReducer,
    functionality: functionalityReducer,
    user: userReducer,
    organisation: organisationReducer,
    filters: filterReducer,
    sharedToast: sharedToastReducer,
    oauth: oauthReducer
};
